import React from 'react';

import SimpleHeader from '../../../components/Headers/SimpleHeader'
import Form from './Form'

const New: React.FC = () => {

  return (
    <>
      <SimpleHeader name="Novo Plano Estratégico" parentName="Planos Estratégicos" />
      <Form />
    </>
  )
}

export default New;